/**
 * The store a request is for, as API params.
 *
 * A store's login ("user" signup) stores its business_id (login.js); the
 * store endpoints (/event/business/list, /event/order/details, ...) then
 * answer for that store only. Any other account sends no business_id.
 *
 * @returns {{ business_id?: string }}
 */
export const businessScopeParams = () => {
  const businessId = localStorage.getItem("business_id");
  return businessId && localStorage.getItem("signup") === "user"
    ? { business_id: businessId }
    : {};
};
